<ui-modal
  class="entities-modal"
  [isOpened]="showEntities"
  modalTitle="Entities"
  (isOpenedChange)="modalChanged($event)"
>
  <div class="entities">
    <ag-grid-angular
      class="ag-theme-balham-dark entities__ag-grid"
      [columnDefs]="$any(columnDefs)"
      [groupDefaultExpanded]="groupDefaultExpanded"
      [masterDetail]="true"
      [detailCellRendererParams]="detailCellRendererParams"
      [detailCellRenderer]="subAccountsComponent"
      [rowSelection]="'single'"
      [isRowMaster]="isRowMaster"
      [singleClickEdit]="true"
      [defaultColDef]="defaultColDef"
      [detailRowHeight]="350"
      (selectionChanged)="onSelectionChanged()"
      (gridReady)="gridReady($event)"
    >
    </ag-grid-angular>

    <div class="entities__footer">
      @if (allowDeleteEntity) {
        <a role="tooltip" class="tooltip tooltip-lg tooltip-top-right">
          <button
            type="button"
            class="ui-button ui-button__header ui-button--danger ui-button--delete"
            [disabled]="selectedEntity == null"
            (click)="deleteEntity()"
          >
            Delete {{ selectedEntity?.identifier }}
          </button>
          <span
            class="tooltip-content"
            aria-haspopup="true"
            *ngIf="selectedEntity != null"
          >
            Deleting this entity will delete all trades, csa's and credit curves
            that this entity is linked to
          </span>
        </a>
      }
      @if (allowAddEntity) {
        <button
          type="button"
          class="ui-button ui-button__header ui-button--primary"
          (click)="addNewEntity()"
          [disabled]="loadingEntities"
        >
          Add Entity
        </button>
      }
    </div>

    @if (!readonly) {
      <div class="entities__save-footer">
        <button
          type="button"
          class="ui-button primary"
          [disabled]="!allowedToSave"
          (click)="saveChanges()"
        >
          <ng-container [ngSwitch]="savingEntitiesStatus">
            <span *ngSwitchCase="''"> Save </span>
            <span
              *ngSwitchCase="'LOADING'"
              class="spinner spinner-sm spinner-inverse"
            >
            </span>
            <span *ngSwitchCase="'DONE'"> Saved </span>
            <span *ngSwitchCase="'ERROR'"> Error </span>
          </ng-container>
        </button>
      </div>
    }
  </div>
</ui-modal>

<ng-template let-row="rowInfo" #entityComponent>
  <ng-container
    *ngIf="row?.rowData && row.colId !== 'ag-Grid-AutoColumn'"
    [formGroup]="entitiesForm"
  >
    <ng-container formArrayName="entities">
      <ng-container [formGroupName]="row.rowData.rowIndex">
        <input
          #checkbox
          clrCheckbox
          type="checkbox"
          [formControlName]="row.colId"
          (change)="updateRow(row.colId, checkbox.checked, row.rowId)"
        />
      </ng-container>
    </ng-container>
  </ng-container>
</ng-template>
